<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Mes Demandes</h2>
        </div>
        <div class="mb-[16px]">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-2 text-black font-light rounded-md">
                    <span v-bind:class="getActiveClass('Congé')" v-on:click="selectBar('Congé')">Congé</span>
                    <span v-bind:class="getActiveClass('Permission')" v-on:click="selectBar('Permission')">Permission</span>
                    <!-- <span v-bind:class="getActiveClass('Heure supplémentaire')" v-on:click="selectBar('Heure supplémentaire')">Heure supplémentaire</span> -->
                    <span v-bind:class="getActiveClass('Document')" v-on:click="selectBar('Document')">Document</span>
                    <span v-bind:class="getActiveClass('Hors bureau')" v-on:click="selectBar('Hors bureau')">Hors bureau</span>
                    <span v-bind:class="getActiveClass('Prévision congé')" v-on:click="selectBar('Prévision congé')">Prévision congé</span>
                    <span v-bind:class="getActiveClass('Prêt/Avance')" v-on:click="selectBar('Prêt/Avance')">Prêt/Avance</span>
                    <span v-bind:class="getActiveClass('Mes offres')" v-on:click="selectBar('Mes offres')">Mes offres</span>
                    <span v-bind:class="getActiveClass('Exit')" v-on:click="selectBar('Exit')">Exit</span>
                    <span class="flex items-center gap-x-5 px-4 py-3 rounded-xl cursor-pointer bg-gray-100 text-black" v-on:click="pushMission">
                        Ordre de mission
                        <SquareArrowOutUpRight :size="18"/>
                    </span>
                </div>
            </div>
        </div>
        <div>
            <Transition @enter="onEnter" @leave="onLeave" :css="false">
                <div v-if="getActiveTab('Congé')" class="w-full">
                    <NewException permType="conge" title="Demande de congé"/>
                </div>
                <div v-else-if="getActiveTab('Permission')" class="w-full">
                    <NewException permType="permission" title="Demande de permission"/>
                </div>
                <div v-else-if="getActiveTab('Heure supplémentaire')" class="w-full">
                    <NewOvertime />
                </div>
                <div v-else-if="getActiveTab('Document')" class="w-full">
                    <NewDoc />
                </div>
                <div v-else-if="getActiveTab('Hors bureau')" class="w-full">
                    <AddHorsService />
                </div>
                <div v-else-if="getActiveTab('Prévision congé')" class="w-full">
                    <newPrevision />
                </div>
                <div v-else-if="getActiveTab('Prêt/Avance')" class="w-full">
                    <PretAvance />
                </div>
                <div v-else-if="getActiveTab('Mes offres')" class="w-full">
                    <SubmitOffer />
                </div>
                <!-- <div v-else-if="getActiveTab('mission')" class="w-full">
                    <OrdreDeMission />
                </div> -->
                <div v-else class="w-full">
                    <exitView />
                </div>
            </Transition>
        </div>
    </section>
</template>
<script>
import NewDoc from "@/components/create/new-doc.vue";
import NewException from "@/components/create/new-exception.vue";
import NewOvertime from "@/components/create/new-overtime.vue";
import AddHorsService from "@/components/create/add-hors-service.vue";
import PretAvance from "@/components/create/pret-avance.vue";
import newPrevision from "@/components/create/new-prevision.vue";
import SubmitOffer from "@/components/create/submit-offer.vue";
import exitView from "@/components/create/exit-view.vue";
import gsap from "gsap";
import {SquareArrowOutUpRight} from "lucide-vue-next"
// import OrdreDeMission from "@/components/create/ordre-mission.vue";
// import API from "@/service/API";
export default{
    name:"MyDemande",
    components:{
        exitView,
        SubmitOffer,
        NewException,
        NewOvertime,
        NewDoc,
        AddHorsService,
        newPrevision,
        PretAvance,
        SquareArrowOutUpRight
        // OrdreDeMission
    },
    data(){return{
        active:"Congé",
    }},
    mounted(){
        // this.getLeaveUser()
    },
    methods:{
        getActiveClass(libelle){
            return `px-4 py-3 rounded-xl cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-gray-100 text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        getActiveTab(libelle){
            return this.active == libelle
        },
        pushMission(){
            this.$router.push({path:"/ordre-mission"})
        },
        onEnter(el, done) {
            gsap.fromTo(el,
                {
                opacity: 0,
                x:15,
                filter: 'blur(2px)',
                },
                {
                    opacity: 1,
                    x:0,
                    filter: 'blur(0px)',
                    duration: 0.15,
                    delay: 0.1,
                    onComplete: done,
                }
            );
        },
        onLeave(el, done) {
            gsap.to(el, {
                opacity: 0,
                x:-15,
                filter: 'blur(2px)',
                duration: 0.15,
                onComplete: done,
            });
        },
    }
}
</script>